//index.js
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AccountTable from "layouts/tablessss/data/tablestructure";
import useAccountsTableData from "layouts/tablessss/data/authorsTableData";
import AccountInfoModal from "./data/AccountInfoModal";

function Tables() {
  const {
    columns,
    rows,
    filterRole,
    setFilterRole,
    selectedAccount,
    setSelectedAccount,
  } = useAccountsTableData();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="warning"
                borderRadius="lg"
                coloredShadow="warning"
              >
                <MDTypography variant="h6" color="white">
                  Account List
                </MDTypography>
              </MDBox> */}
              <MDBox pt={3}>
                <AccountTable
                  table={{ columns, rows }}
                  isSorted
                  entriesPerPage
                  showTotalEntries
                  canSearch
                  noEndBorder
                  filterRole={filterRole}
                  setFilterRole={setFilterRole}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Modal */}
      <AccountInfoModal
        open={!!selectedAccount}
        account={selectedAccount}
        onClose={() => setSelectedAccount(null)}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Tables;